import { Divider } from "@mui/material";
import { FC } from "react";

export const ThemeAwareDivider: FC = () => <Divider sx={{ borderColor: "sidebar.divider" }} />;
